<template>
    <button
        class="message_btn flex items-center justify-center text-sm font-medium text-white cursor-pointer"
        @click="openModal('new_message')"
    >
        <fa :icon="['fas', 'plus']" class="mr-1"></fa>
        {{ label || "New chat" }}
    </button>
    <!-- <div> -->
    <!-- <VDropdown
            :prevent-overflow="false"
            :shown="false"
            :overflow-padding="60"
            auto-boundary-max-size
            placement="bottom-start"
            theme="messageMenu"
        >
        <button>DE</button>
            <template #popper>
                <div>
                    <NewMessageDropdown1 />
                </div>
            </template>
        </VDropdown> -->

    <NewMessageModal v-if="hasRole('new_message')" />
    <!-- </div> -->
</template>

<script setup>
// [todo]: cleanup
// import NewMessageDropdown1 from "./dropdowns/NewMessageDropdown1.vue";
import NewMessageModal from "./modals/newMessage/NewMessageModal.vue";
import useToggleModal from "@/composables/useToggleModal";

defineProps({
    label: String,
});

const { hasRole, openModal } = useToggleModal();
</script>

<style scoped>
.message_btn {
    @apply h-8 py-[10px] px-3 bg-blue-500 border border-blue-500 rounded;
}
</style>

<!-- [todo]: what is the purpose of this being here? This could effect all the v-popper__inner classes all over the app. Should I add it in scroped? -->
<style>
body .v-popper--theme-messageMenu .v-popper__inner {
    max-width: 477px !important;
    min-width: 0px !important;
    width: 477px !important;
}
</style>
